import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useLocale } from '@/hooks';
import { InformationmarkSmallCircleFillIcon } from '@/icons/components/InformationmarkSmallCircleFill';
import { Button } from '@/ui_v3/components/button';
import { cn } from '@/utils/tailwind.util';
import { type VoucherGuideState } from './type';
const VOUCHER_GUIDE_URL: Record<string, string> = {
  ko: 'https://docs.channel.io/zepquiz/ko/articles/%EC%9D%B4%EC%9A%A9%EA%B6%8C-%EA%B0%80%EC%9D%B4%EB%93%9C-ed92f5b1',
  ja: 'https://docs.channel.io/zepquiz/ja/articles/%EC%9D%B4%EC%9A%A9%EA%B6%8C-%EA%B0%80%EC%9D%B4%EB%93%9C-ed92f5b1',
  en: 'https://docs.channel.io/zepquiz/en/articles/%EC%9D%B4%EC%9A%A9%EA%B6%8C-%EA%B0%80%EC%9D%B4%EB%93%9C-ed92f5b1'
};
const VOUCHER_GUIDE_UI_CONFIG = {
  available: {
    message: 'voucher.info.available',
    bgColor: 'bg-green-50',
    textColor: 'text-semi-strong',
    iconColor: ICON_COLOR.semistrong,
    buttonBgColor: 'bg-mint-700',
    buttonTextColor: undefined,
    buttonHoverColor: 'hover:bg-mint-800'
  },
  plain: {
    message: 'voucher.info.plain',
    bgColor: 'bg-gray-50',
    textColor: 'text-neutral',
    iconColor: ICON_COLOR.alternative,
    buttonBgColor: 'bg-gray-50',
    buttonTextColor: 'text-neutral',
    buttonHoverColor: 'hover:bg-gray-100'
  },
  destructive: {
    message: 'voucher.info.destructive',
    bgColor: 'bg-red-50',
    textColor: 'text-neutral',
    iconColor: ICON_COLOR.destructive,
    buttonBgColor: 'bg-red-50',
    buttonTextColor: 'text-destructive',
    buttonHoverColor: 'hover:bg-red-100'
  }
} as const satisfies Record<VoucherGuideState, {
  message: string;
  bgColor: string;
  textColor: string;
  iconColor: string;
  buttonBgColor: string;
  buttonTextColor?: string;
  buttonHoverColor: string;
}>;
export const VoucherGuideBar = ({
  state
}: {
  state: VoucherGuideState;
}) => {
  const {
    locale
  } = useLocale();
  const {
    t
  } = useTranslation(['billing']);
  const uiConfig = VOUCHER_GUIDE_UI_CONFIG[state];
  return <div className={cn('flex w-full items-center gap-xs rounded-md px-md py-sm mobile-lg:gap-md mobile-lg:px-lg', uiConfig.bgColor)} data-sentry-component="VoucherGuideBar" data-sentry-source-file="VoucherGuideBar.tsx">
      <div className="flex size-[16px] shrink-0 items-center justify-center mobile-lg:size-[20px]">
        <InformationmarkSmallCircleFillIcon color={uiConfig.iconColor} className="size-[16px] mobile-lg:size-[20px]" data-sentry-element="InformationmarkSmallCircleFillIcon" data-sentry-source-file="VoucherGuideBar.tsx" />
      </div>
      <p className={cn('flex-1 text-[11px] font-semibold leading-[15.4px] mobile-lg:text-caption-lg-semibold', uiConfig.textColor)}>
        {t(uiConfig.message)}
      </p>
      <Button variant="contained" size="xs" className={cn('shrink-0 text-[11px] mobile-lg:text-caption-lg-semibold', uiConfig.buttonBgColor, uiConfig.buttonTextColor, uiConfig.buttonHoverColor)} onClick={() => {
      logger.track('click_voucher_guide');
      window.open(VOUCHER_GUIDE_URL[locale] ?? VOUCHER_GUIDE_URL['en'], '_blank');
    }} data-sentry-element="Button" data-sentry-source-file="VoucherGuideBar.tsx">
        {t('voucher.guide')}
      </Button>
    </div>;
};